import dayjs from 'dayjs';
import * as pt_br from 'dayjs/locale/pt-br';

dayjs.locale(pt_br);

export const fixMinMaxForDatePicker = (date: number | string | undefined) => {
  if (!date) {
    return undefined;
  }

  const dayjsDate = dayjs(date).add(dayjs(date).utcOffset() * -1, 'minute');

  return dayjsDate.valueOf();
};
